import { useApi } from '~shared/providers/use-api';

import { useMutation, useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import type { FindPaymentsRequestParams } from './find-payments-params';
import type { Payment } from './payment';

import type { PaymentsApi } from '../api';
import { PAYMENTS_API_KEY } from '../api';

export const useFindPaymentsQuery = (
  requestOptions: FindPaymentsRequestParams,
  options: UseQueryOptions<{ payments: Payment[]; total: number }> = {}
) => {
  const paymentsApi = useApi<PaymentsApi>(PAYMENTS_API_KEY);

  return useQuery({
    queryKey: ['find-payments', requestOptions],
    queryFn: async () => {
      const { items, pageInfo } =
        await paymentsApi.findPayments(requestOptions);

      return {
        payments: items,
        total: pageInfo.total,
      };
    },
    keepPreviousData: true,
    ...options,
  });
};

export const useGenerateReportMutation = () => {
  const paymentsApi = useApi<PaymentsApi>(PAYMENTS_API_KEY);

  return useMutation({
    mutationKey: ['generate-report'],
    mutationFn: async (requestParams: FindPaymentsRequestParams) =>
      paymentsApi.generateReport(requestParams),
  });
};
